export default function Unauthorized() {
  return <h1>You are not authorized to view this page</h1>;
}
